import { render, staticRenderFns } from "./unverified.vue?vue&type=template&id=ffdd8ac4"
import script from "./unverified.vue?vue&type=script&lang=js"
export * from "./unverified.vue?vue&type=script&lang=js"
import style0 from "./unverified.vue?vue&type=style&index=0&id=ffdd8ac4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports